const tabs = {
  data () {
    return {
      tab: null,
      first: true
    }
  },
  watch: {
    tab: function (val) {
      if (!this.first && this.routerPath.page_path !== val) {
        this.$router.push({
          name: `${this.routerPath.root}${(val !== 'default' ? ':' + this.routerPath.page_mode : '')}`,
          params: {
            page: (val !== 'default' ? val : false)
          }
        }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      }
      this.first = false
    },
    'routerPath': {
      deep: true,
      handler (path) {
        this.initTabs(path)
      }
    }
  },
  methods: {
    initTabs (path) {
      const page = (path.page_path && this.tabs().includes(path.page_path))
      this.tab = (page ? path.page_path : this.tabs()[0])
      if (!page && this.tabs()[0] !== 'default') {
        this.$router.replace({
          name: `${this.routerPath.root}:${this.routerPath.page_mode}`,
          params: {
            page: this.tabs()[0].toString()
          }
        }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
      }
    }
  },
  created () {
    if (this.routerPath) this.initTabs(this.routerPath)
  }
}

export default tabs
